import { Flame, Target, TrendingUp, CheckCircle2 } from 'lucide-react';

interface StatsHeaderProps {
  totalGoals: number;
  totalStreak: number;
  todayProgress: number;
}

export const StatsHeader = ({ totalGoals, totalStreak, todayProgress }: StatsHeaderProps) => {
  const stats = [
    {
      label: 'Active Goals',
      value: totalGoals,
      icon: <Target className="w-5 h-5" />,
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
    {
      label: 'Total Streak',
      value: totalStreak === 0 ? 'Start your streak!' : totalStreak,
      icon: <Flame className="w-5 h-5" />,
      color: 'text-warning',
      bg: 'bg-warning/10',
    },
    {
      label: todayProgress === 0 && totalStreak === 0 ? 'Next Step' : "Today's Progress",
      value: todayProgress === 0 && totalStreak === 0 ? 'Add habits!' : `${todayProgress}%`,
      icon: todayProgress === 0 && totalStreak === 0 ? <TrendingUp className="w-5 h-5" /> : <CheckCircle2 className="w-5 h-5" />,
      color: todayProgress === 0 && totalStreak === 0 ? 'text-primary' : 'text-success',
      bg: todayProgress === 0 && totalStreak === 0 ? 'bg-primary/10' : 'bg-success/10',
    },
  ];

  return (
    <div data-tour="stats-header" className="grid grid-cols-1 sm:grid-cols-3 gap-4 pointer-events-none">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="card-elevated rounded-xl p-5 border border-border/50 animate-fade-in"
        >
          <div className="flex items-center gap-3">
            <div className={`p-2.5 rounded-lg ${stat.bg}`}>
              <span className={stat.color}>{stat.icon}</span>
            </div>
            <div>
              <div className="text-2xl font-display font-bold">{stat.value}</div>
              <div className="text-sm text-muted-foreground">{stat.label}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
